/*
 * Lentila product reviews widget (self-contained, no dependencies).
 * Talks to the Firebase App Proxy (/apps/reviews).
 *  - GET  ?productId=  : approved reviews + summary
 *  - POST {productId, rating, title, body, photos[]} : submit (verified server-side)
 * Photos are downscaled on the client before upload to keep the payload small.
 */
(function () {
  'use strict';

  var MAX_PHOTOS = 4;
  var MAX_DIM = 1280; // max width/height (px) after downscaling

  var ERROR_MESSAGES = {
    login_required: 'Please log in to write a review.',
    not_purchased: 'We could not verify a purchase for this product.',
    already_reviewed: 'You have already reviewed this product.',
    invalid_rating: 'Please select a star rating.',
    invalid_body: 'Please enter at least 10 characters.',
    invalid_photo: 'One of your photos could not be processed.',
    invalid_email: 'Please enter a valid email address.',
    order_required: 'Please enter your order number.',
    order_not_found: 'We could not find a purchase of this product for that order number and email.',
    bad_signature: 'Request verification failed. Please refresh the page.',
    default: 'Something went wrong. Please try again later.',
  };

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function stars(n) {
    n = Math.round(n) || 0;
    return '★'.repeat(n) + '☆'.repeat(5 - n);
  }

  function fmtDate(iso) {
    if (!iso) return '';
    return String(iso).slice(0, 10);
  }

  function init(root) {
    if (root.__lrInit) return; // init once even if the script loads twice
    root.__lrInit = true;

    var proxy = root.getAttribute('data-proxy') || '/apps/reviews';
    var productId = root.getAttribute('data-product-id');
    var productHandle = root.getAttribute('data-product-handle');

    var listEl = root.querySelector('[data-lr-list]');
    var summaryEl = root.querySelector('[data-lr-summary]');
    var moreEl = root.querySelector('[data-lr-more]');
    var form = root.querySelector('[data-lr-form]');
    var openBtn = root.querySelector('[data-lr-open]');
    var modal = root.querySelector('[data-lr-modal]');
    var photos = []; // array of data URLs
    var VISIBLE = 5; // reviews shown before "Show more"

    loadReviews();

    // ---- Modal open/close ----
    if (openBtn && modal) {
      openBtn.addEventListener('click', openModal);
    }
    root.querySelectorAll('[data-lr-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    if (form) setupForm();

    // ---- Load list ----
    function loadReviews() {
      fetch(proxy + '?productId=' + encodeURIComponent(productId), {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {
          listEl.innerHTML = '<p class="lentila-reviews__empty">Could not load reviews.</p>';
        });
    }

    function render(data) {
      var reviews = (data && data.reviews) || [];
      var summary = (data && data.summary) || { average: 0, count: 0 };

      if (summary.count > 0) {
        summaryEl.innerHTML =
          '<span class="lentila-reviews__summary-avg">' + summary.average.toFixed(1) + '</span>' +
          '<span class="lentila-reviews__stars">' + stars(summary.average) + '</span>' +
          '<span class="lentila-reviews__item-date">' + summary.count +
          (summary.count === 1 ? ' review' : ' reviews') + '</span>';
      } else {
        summaryEl.innerHTML = '<span class="lentila-reviews__item-date">No reviews yet. Be the first to review!</span>';
      }

      if (moreEl) moreEl.innerHTML = '';
      if (!reviews.length) {
        listEl.innerHTML = '<p class="lentila-reviews__empty">No reviews yet.</p>';
        return;
      }

      listEl.innerHTML = reviews.map(function (r) {
        var photoHtml = (r.photos || []).map(function (p) {
          return '<img src="' + esc(p) + '" alt="Review photo" loading="lazy" onclick="window.open(this.src)">';
        }).join('');
        return (
          '<div class="lentila-reviews__item">' +
            '<div class="lentila-reviews__item-head">' +
              '<span class="lentila-reviews__stars">' + stars(r.rating) + '</span>' +
              '<span class="lentila-reviews__item-name">' + esc(r.customerName) + '</span>' +
              (r.verified ? '<span class="lentila-reviews__badge">Verified</span>' : '') +
              '<span class="lentila-reviews__item-date">' + fmtDate(r.createdAt) + '</span>' +
            '</div>' +
            (r.title ? '<p class="lentila-reviews__item-title">' + esc(r.title) + '</p>' : '') +
            '<p class="lentila-reviews__item-body">' + esc(r.body) + '</p>' +
            (photoHtml ? '<div class="lentila-reviews__item-photos">' + photoHtml + '</div>' : '') +
          '</div>'
        );
      }).join('');

      // Show only the first VISIBLE reviews; reveal the rest with "Show more".
      var items = listEl.querySelectorAll('.lentila-reviews__item');
      if (moreEl && items.length > VISIBLE) {
        for (var k = VISIBLE; k < items.length; k++) items[k].classList.add('is-hidden');
        var hiddenCount = items.length - VISIBLE;
        moreEl.innerHTML =
          '<button type="button" class="lentila-reviews__more-btn">Show more (' + hiddenCount + ')</button>';
        moreEl.querySelector('button').addEventListener('click', function () {
          listEl.querySelectorAll('.lentila-reviews__item.is-hidden').forEach(function (el) {
            el.classList.remove('is-hidden');
          });
          moreEl.innerHTML = '';
        });
      }
    }

    // ---- Form ----
    function setupForm() {
      var ratingInput = form.querySelector('input[name="rating"]');
      var starBtns = form.querySelectorAll('[data-lr-stars] .lentila-reviews__star');
      var photoInput = form.querySelector('[data-lr-photos]');
      var previews = form.querySelector('[data-lr-previews]');
      var msg = form.querySelector('[data-lr-msg]');

      starBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(btn.getAttribute('data-value'), 10);
          ratingInput.value = val;
          starBtns.forEach(function (b) {
            b.classList.toggle('is-on', parseInt(b.getAttribute('data-value'), 10) <= val);
          });
        });
      });

      photoInput.addEventListener('change', function () {
        var files = Array.prototype.slice.call(photoInput.files);
        photoInput.value = '';
        files.forEach(function (file) {
          if (photos.length >= MAX_PHOTOS) return;
          if (!/^image\//.test(file.type)) return;
          shrink(file, function (dataUrl) {
            if (photos.length >= MAX_PHOTOS) return;
            photos.push(dataUrl);
            renderPreviews();
          });
        });
      });

      function renderPreviews() {
        previews.innerHTML = photos.map(function (p, i) {
          return '<figure><img src="' + p + '" alt=""><button type="button" data-i="' + i + '">×</button></figure>';
        }).join('');
        previews.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            photos.splice(parseInt(b.getAttribute('data-i'), 10), 1);
            renderPreviews();
          });
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var rating = parseInt(ratingInput.value, 10) || 0;
        var title = form.querySelector('input[name="title"]').value.trim();
        var body = form.querySelector('textarea[name="body"]').value.trim();

        setMsg('', '');
        if (!rating) return setMsg(ERROR_MESSAGES.invalid_rating, 'is-error');
        if (body.length < 10) return setMsg(ERROR_MESSAGES.invalid_body, 'is-error');

        var payload = {
          productId: productId,
          productHandle: productHandle,
          rating: rating,
          title: title,
          body: body,
          photos: photos,
        };

        // Guest: include email + order number if those fields are present.
        var emailEl = form.querySelector('input[name="email"]');
        var orderEl = form.querySelector('input[name="orderNumber"]');
        if (emailEl && orderEl) {
          var email = emailEl.value.trim();
          var orderNumber = orderEl.value.trim();
          if (!EMAIL_RE.test(email)) return setMsg(ERROR_MESSAGES.invalid_email, 'is-error');
          if (!orderNumber) return setMsg(ERROR_MESSAGES.order_required, 'is-error');
          payload.email = email;
          payload.orderNumber = orderNumber;
        }

        var submitBtn = form.querySelector('.lentila-reviews__submit');
        submitBtn.disabled = true;
        setMsg('Submitting…', '');

        fetch(proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, body: j }; });
          })
          .then(function (res) {
            submitBtn.disabled = false;
            if (res.ok && res.body.ok) {
              form.reset();
              photos = [];
              renderPreviews();
              starBtns.forEach(function (b) { b.classList.remove('is-on'); });
              ratingInput.value = 0;
              setMsg('Thanks! Your review was submitted and will appear after approval.', 'is-ok');
            } else {
              var code = (res.body && res.body.error) || 'default';
              setMsg(ERROR_MESSAGES[code] || ERROR_MESSAGES.default, 'is-error');
            }
          })
          .catch(function () {
            submitBtn.disabled = false;
            setMsg(ERROR_MESSAGES.default, 'is-error');
          });
      });

      function setMsg(text, cls) {
        msg.textContent = text;
        msg.className = 'lentila-reviews__msg' + (cls ? ' ' + cls : '');
      }
    }

    // Downscale an image file to a JPEG data URL
    function shrink(file, cb) {
      var img = new Image();
      var reader = new FileReader();
      reader.onload = function () {
        img.onload = function () {
          var w = img.width, h = img.height;
          if (w > h && w > MAX_DIM) { h = Math.round((h * MAX_DIM) / w); w = MAX_DIM; }
          else if (h >= w && h > MAX_DIM) { w = Math.round((w * MAX_DIM) / h); h = MAX_DIM; }
          var canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          cb(canvas.toDataURL('image/jpeg', 0.8));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  function boot() {
    document.querySelectorAll('[data-lentila-reviews]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
